import {
    ORDERS_REQUEST_START,
    ORDERS_REQUEST_SUCCESS,
    ORDERS_REQUEST_FAILED,
    ORDERS_REQUEST_NO_PERMISSION,
    ORDERS_INSERT,
    ORDERS_UPDATE,
    ORDERS_DELETE,
    ORDERS_OPEN_UPDATE_FORM,
    ORDERS_UPDATE_FIELD

} from '../actions/OrdersActions';

const initialState = {
    status: 'Initialize'
};

export default function OrdersReducer(state = initialState, action) {

    if (!action) {
        return state;
    }

    switch (action.type) {
        case ORDERS_REQUEST_START:
            return {
                ...state, status: 'request', country: action.country, date: action.date,
                product: action.product,
                platform: action.platform
            };
        case ORDERS_REQUEST_SUCCESS:
            return {...state, status: 'success', data: action.data};
        case ORDERS_REQUEST_NO_PERMISSION:
            return {...state, status: 'no_permission'};
        case ORDERS_REQUEST_FAILED:
            return {...state, status: 'error'};
        case ORDERS_OPEN_UPDATE_FORM:
            return {...state,errorUpdate:false,orderInEdit:action.order};
        case ORDERS_UPDATE_FIELD:
            var updatedAffiliate = {...state.orderInEdit};
            updatedAffiliate[action.field] = action.value;
            return {...state,errorUpdate:false, orderInEdit: updatedAffiliate};
        case ORDERS_INSERT:
            /*const modifiedCustomers = [...state.data, action.customer];

            return {...state, data: modifiedCustomers };*/
            var modifiedCustomers = [];
            for (var index in state.data){
                modifiedCustomers.push(state.data[index] );
            }

            modifiedCustomers.push(action.customer);

            return {...state,data:modifiedCustomers,errorUpdate:false};
        case ORDERS_UPDATE:

            /*const updatedCustomers = [...state.data];
            updatedCustomers[action.index] = action.customer;

            return {...state, data: updatedCustomers };*/

            let tmp = state.data;

            var updatedCustomers = [];
            for (var index in state.data.orders){

                if (state.data.orders[index].id === action.order.id){

                    updatedCustomers.push(action.order);
                }
                else{
                    updatedCustomers.push(state.data.orders[index]);

                }
            }
            tmp.orders = updatedCustomers;

            return {...state,data:tmp,errorUpdate:false};

        case ORDERS_DELETE:

            let modifiedCustomers = {orders: [], stat: state.data.stat};

            //console.log(modifiedCustomers)

            for (var index in state.data.orders){

                if (state.data.orders[index].id !== action.id){

                    modifiedCustomers.orders.push({...state.data.orders[index] });
                }
            }

            return {...state,data:modifiedCustomers,errorUpdate:false};

        default:
            return state;
    }
}
